import $ from "jquery";

const populateEitherField = (
  $valueField: HTMLInputElement,
  $subfield: HTMLInputElement,
  triggeredByTyping: boolean,
) => {
  let value = "";
  const prefix = $subfield.dataset.prefix;
  const suffix = $subfield.dataset.suffix;

  if ($subfield.value) {
    value = prefix + $subfield.value + suffix;
  }

  value = value.trim();

  $valueField.value = value;

  if (triggeredByTyping) {
    $($valueField).valid();
  }
};

const checkValidity = ($field: HTMLElement, $valueField: HTMLInputElement) => {
  const invalid = $valueField.getAttribute("aria-invalid");
  if (invalid === "true") {
    $field.classList.add("composite-error");
  } else {
    $field.classList.remove("composite-error");
  }
};

const eitherFields = () => {
  const eitherFieldsList = document.querySelectorAll(".js-either-field");

  if (!eitherFieldsList.length) {
    return;
  }

  eitherFieldsList.forEach(($field: HTMLElement) => {
    const subfields = $field.querySelectorAll("input[type=text]");
    const $valueField = document.getElementById(
      $field.dataset.field,
    ) as HTMLInputElement;

    if (!subfields.length || !$valueField) {
      return;
    }

    subfields.forEach(($subfield: HTMLInputElement, index: number) => {
      $subfield.addEventListener("input", () => {
        // On subfield change, populate hidden field with concatenated
        populateEitherField($valueField, $subfield, true);

        // Clear the alternative input
        console.log("Should clear the other input");
        const arrayOfSubfields = Array.from(subfields);
        const alternativeInput = arrayOfSubfields.filter(
          (element: HTMLInputElement) => {
            if (element !== $subfield) {
              element.value = "";
            }
          },
        );
        // Ensure when validation occurs on hidden field that whole field is error-stated
        setTimeout(() => {
          checkValidity($field, $valueField);
        }, 0);
      });

      // Run population once on initial load
      populateEitherField($valueField, $subfield, false);

      // Run population once on back/forward button presses
      // https://stackoverflow.com/questions/8861181/clear-all-fields-in-a-form-upon-going-back-with-browser-back-button#answer-8861236
      window.addEventListener("pageshow", () => {
        populateEitherField($valueField, $subfield, false);
      });
    });

    // Pasting into the first field should fill correctly
    const $firstField = $field.querySelector("input");
    $firstField.addEventListener("paste", (e) => {
      const $target = e.target as HTMLInputElement;
      // if the target is a text input
      if ($target.type === "text") {
        const pasteText = e.clipboardData.getData("Text");
        // Regex used to intelligently handle variety of input formats
        // e.g 01/01/1990, 01-01-1990, or 01 01 1990 will all work as intended
        const data = pasteText
          .replace(/\//g, "")
          .replace(/-/g, "")
          .replace(/ /g, "")
          .split("");
        let dataPos = 0;
        let pasteComplete = false;

        // Iterate through subfields, entering data
        subfields.forEach(($subfield: HTMLInputElement, index: number) => {
          // If paste is complete no need to keep going
          if (pasteComplete) {
            return;
          }

          // If the pasted text fits into the field, or the field has no restriction so anything will fit
          // Just drop it in and consider this done
          if (!$subfield.maxLength || data.length <= $subfield.maxLength) {
            $subfield.value = pasteText;
            pasteComplete = true;
            return;
          }

          let subfieldValue = "";
          for (let i = 0; i < $subfield.maxLength; i++) {
            // If there's no more data to process we must be done
            if (!data[dataPos]) {
              pasteComplete = true;
              return;
            }

            subfieldValue += data[dataPos];
            dataPos += 1;
          }
          $subfield.value = subfieldValue;
        });
      }
    });
  });
};

export default eitherFields;
